/** Append `?company=<slug>` to a URL when a company filter is active. */
export function withCompany(url: string, company: string | null): string {
  if (!company) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}company=${encodeURIComponent(company)}`;
}
